import React from 'react';
import Hero from './Hero'; // Import the Hero component
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero isHomePage={true} />
      <div className="info-section">
        <div className="location-details">
          <div className="info-card">
            <h3>Location</h3>
            <div className="address-and-button">
              <p><strong>3 Alexandra St,</strong></p>
              <a
                href="https://www.google.com/maps/place/Faith+Tabernacle+Church+Kettering+-+a+malayalam+pentecostal+fellowship/@52.4005269,-0.7248892,17z/data=!3m1!4b1!4m6!3m5!1s0x48779fcfae0896c1:0xa5c3237907a5aeb5!8m2!3d52.4005269!4d-0.7223143!16s%2Fg%2F11pvh8c_5z?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D"
                className="directions-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <p><strong>Kettering NN16 0SX</strong></p>
            <div className="service-times">
              <p>Sunday School: 09:30 AM</p>
              <p>Sunday Service: 10:00 AM - 1:00 PM</p>
            </div>
            <a
              href="/events"
              className="directions-button upcoming-events-button"
            >
              Upcoming Events
            </a>
          </div>
        </div>
        <div className="map-section">
          <div className="map-card">
            <img 
              src="/church-map.png" 
              alt="Church Location Map" 
              className="static-map"
            />
          </div>
        </div>
      </div>
      
      {/* Add other landing page content here */}
    </div>
  );
};

export default LandingPage;
